import React from "react";
import BannerFormPage from "features/MarketingBanner/presentation/pages/BannerForm";

function BannerEditScreen() {
  return <BannerFormPage />;
}

export default BannerEditScreen;
